module.exports = __webpack_public_path__ + "img/card_bg.3f5733ab.jpg";